export const updateDataConstants = {
    UPDATE_DATA_SUCCESS : "UPDATE_DATA_SUCCESS",
    UPDATE_DATA_FAILURE : "UPDATE_DATA_FAILURE"
}